<template>
<div>
    <Breadcrumbs main="Admin" submain="Operation" title="Sidebar Menu" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div style="display: flex; gap: 16px;">
                            <h6 class="pt-1">Sidebar Changed?</h6>
                            <input class="custom-checkbox" type="checkbox" id="flexSwitchCheck" v-model="mainToggle" @change="handleMainToggle()" />
                        </div>
                        <div class="mt-4" v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="sidebar_list" :fields="tablefields">
                                    <template #cell(index)="data">
                                        {{ data.index + 1 }}
                                    </template>

                                    <template #cell(title)="row">
                                        <div v-if="row.item.title">
                                            <h7>{{ row.item.title }}</h7>
                                        </div>
                                    </template>

                                    <template #cell(visibility)="row">
                                        <span style="display: flex; gap: 12px; cursor: pointer;">
                                            <input class="custom-checkbox" type="checkbox" id="flexSwitchCheck" v-model="row.item.visibility" @change="handleToggle(row.item.slug)" />
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import {
    myHost
} from '../../../_helpers/host';
import loader from '../loader/loader.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
    components: {
        loader
    },

    data() {
        return {
            host: myHost.host,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'name',
                    label: 'Menu',
                    sortable: false
                },
                {
                    key: 'visibility',
                    label: 'Visibility',
                    sortable: false
                }
            ]
        };
    },

    computed: {
        ...mapState({
            sidebar_list: state => state.sidebar.sidebar,
            mainToggle: state => state.sidebar.mainToggle,
            loading: state => state.sidebar.sidebarLoading,
            error: state => state.sidebar.sidebarError
        })
    },

    watch: {
        mainToggle(oldVal, newVal) {}
    },

    mounted() {
        this.$store.dispatch("sidebar/fetchMainToggle")
        this.$store.dispatch("sidebar/fetchSidebar")
    },

    methods: {
        handleToggle(menu) {
            this.$store.dispatch("sidebar/toggleSidebar", menu).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        handleMainToggle() {
            this.$store.dispatch("sidebar/toggleMainSidebar").then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>

<style scoped>
.custom-checkbox {
    width: 24px;
    height: 24px;
    display: inline-block;
    background-color: #f0f0f0;
    border-radius: 4px;
    border: 2px solid #262162;
    position: relative;
    margin-right: 10px;
    transition: all 0.2s;
}
</style>
